var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"raidersRight_page"},[_c('img',{ref:"bgRef",staticClass:"bg",attrs:{"src":require("../../sprite/community.jpg"),"alt":""}}),_c('img',{staticClass:"qr_code",attrs:{"src":require("../../sprite/customer_service_QRcode.jpg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }